import {isAuthenticated, signIn, signOut} from "../../shared/services/ad_b2c/authRedirect";
import CONFIG from "../../config/config";


const state = {
  b2cAccount: JSON.parse(localStorage.getItem("user_B2C_Account")),

  account: JSON.parse(sessionStorage.getItem("loggedAs")) ?
    JSON.parse(sessionStorage.getItem("loggedAs")) :
    JSON.parse(localStorage.getItem("userAccount")),

  loggedAs: JSON.parse(sessionStorage.getItem("loggedAs")),
  connectedRole: JSON.parse(localStorage.getItem("connectedRole"))
}

const getters = {
  isAuthenticated(state) {
    return !!state.account && !!state.b2cAccount;
  },
  idTokenKey(state) {
    const homeAccountId = state.b2cAccount ? state.b2cAccount.homeAccountId : null;
    const environment = state.b2cAccount ? state.b2cAccount.environment : null;
    const clientId = CONFIG.BASE_AZURE_TENANT_CLIENT_ID;
    const tenantId = state.b2cAccount ? state.b2cAccount.tenantId : null;
    return homeAccountId + "-" + environment + "-idtoken-" + clientId + "-" + tenantId + "-";
  },
  refreshTokenKey(state) {
    const homeAccountId = state.b2cAccount ? state.b2cAccount.homeAccountId : null;
    const environment = state.b2cAccount ? state.b2cAccount.environment : null;
    const clientId = CONFIG.BASE_AZURE_TENANT_CLIENT_ID;
    return homeAccountId + "-" + environment + "-refreshtoken-" + clientId + "--";
  },
  idToken(state) {
    return JSON.parse(
      localStorage.getItem(getters.idTokenKey(state)))
      ? JSON.parse(localStorage.getItem(getters.idTokenKey(state))).secret
      : null;
  },
  refreshToken(state) {
    return JSON.parse(
      localStorage.getItem(getters.refreshTokenKey(state)))
      ? JSON.parse(localStorage.getItem(getters.refreshTokenKey(state))).secret
      : null;
  },
  userPersonalDetails(state) {
    return {
      firstName: state.account ? state.account.firstName : null,
      lastName: state.account ? state.account.lastName : null,
      email: state.account ? state.account.email : null,
      language: state.account ? state.account.language : null
    }
  },
  userPersonalContacts(state) {
    return {
      phone: state.account ? state.account.phone : null,
      sms: state.account ? state.account.sms : null,
    }
  },
  portalId(state) {
    return state.b2cAccount ? state.b2cAccount.localAccountId : null;
  },
  id(state) {
    return state.account ? state.account.id : null
  },
  phone(state) {
    return state.account ? state.account.phone : null
  },
  navId(state) {
    return state.account ? state.account.navId : null
  },
  fullName(state) {
    return state.account ? state.account.name : null
  },
  userEmail(state) {
    return state.account ? state.account.email : null
  },
  inMaintenance(state) {
    return state.account ?(state.account.scopeDefault.status.toLowerCase() === "maintenance") : false;
  },
  allScopes(state) {
    return state.account ? state.account.scopes : null;
  },
  scopeDefault(state) {
    return state.account ? state.account.scopeDefault : null;
  },
  role(state) {
    if (!state.account.userHasMultiRole) {
      return state.account.role.name;
    } else if (state.account.userHasMultiRole) {
      return state.connectedRole ? state.account.roles.find(role => role.name === state.connectedRole).name : state.account.role.name;
    } else {
      return null;
    }
  },
  userHasMultiRole(state) {
    return state.account ? state.account.userHasMultiRole : null;
  },
  connectedRole(state) {
    return state.account ? state.connectedRole : null;
  },
  permissions(state) {
    return state.account ? state.account.permissions : null;
  },
  language(state) {
    return state.account ? state.account.language.code : null;
  },
  loggedAs(state) {
    return state.loggedAs;
  },
  isLoggedAs(state) {
    return !!state.loggedAs
  },
  availableScopes(state) {
    return state.account ? state.account.scopes.map(scope => scope.url) : null;
  },
  hasAccessToScope(state) {
    return state.account ? state.account.hasAccessToConnectedScope : true;
  },
  level(){
    return state.account ?state.account.level:null;
  },
  scopeDefaultIsAbsencesEnabled(){
    return state.account ? state.account.scopeDefault.is_absences_enabled : null;
  }
}

const actions = {
  signIn({commit}, redirectUri = null) {
    commit('updateAuthData');
    signIn(redirectUri);
  },
  logout({commit}) {
    localStorage.clear();
    sessionStorage.clear();
    commit('clearAuthData');
    signOut();
  },
  logAs({commit}, user) {
    commit('setLogAs', user);
  },
  setUserAccountAction({commit}, user) {
    commit('setUserAccount', user);
  },
  setUserPhone({commit}, phone) {
    commit("setUserPhone", phone);
  },
  setUserSms({commit}, sms) {
    commit("setUserSms", sms);
  },
  existLogAs({commit}) {
    commit('clearLogAs', null);
    commit('updateAuthData');
  },
  updateUserEmail({commit}, newEmail) {
    commit("updateUserEmail", newEmail);
  },
  updateConnectedRole({commit}, newRole) {
    commit("updateConnectedRole", newRole);
  }
}

const mutations = {
  clearAuthData(state) {
    state.b2cAccount = null;
    state.account = null;
    state.loggedAs = null;
  },
  updateAuthData(state) {
    state.b2cAccount = JSON.parse(localStorage.getItem("user_B2C_Account"));
    state.account = JSON.parse(localStorage.getItem("userAccount"))
  },
  setUserB2CAccount(state, userB2CAccount) {
    state.b2cAccount = userB2CAccount;
  },
  setUserAccount(state, userAccount) {
    state.account = userAccount;
  },
  setUserPersonalDetails(state, userPersonalDetails) {
    state.account.language = userPersonalDetails.language;
    localStorage.setItem("userAccount", JSON.stringify(state.account));
  },
  setUserPhone(state, phone) {
    state.account.phone = phone;
    localStorage.setItem("userAccount", JSON.stringify(state.account));
  },
  setUserSms(state, sms) {
    state.account.sms = sms;
    localStorage.setItem("userAccount", JSON.stringify(state.account));
  },
  setTokens(state, tokens) {
    const idToken = JSON.parse(localStorage.getItem(getters.idTokenKey(state)));
    idToken.secret = tokens.newIdToken;
    localStorage.setItem(getters.idTokenKey(state), JSON.stringify(idToken))
    const refreshToken = JSON.parse(localStorage.getItem(getters.refreshTokenKey(state)));
    refreshToken.secret = tokens.newRefreshToken;
    localStorage.setItem(getters.refreshTokenKey(state), JSON.stringify(refreshToken));
  },
  setLogAs(state, user) {
    sessionStorage.setItem("loggedAs", JSON.stringify(user));
    state.loggedAs = user;
    state.account = user;
  },
  clearLogAs(state) {
    state.loggedAs = null;
    sessionStorage.removeItem("loggedAs");
  },
  updateUserEmail(state, newEmail) {
    state.account.email = newEmail;
  },
  updateConnectedRole(state, newRole) {
    localStorage.setItem("connectedRole", newRole);
    state.connectedRole = newRole;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
